export default __webpack_public_path__ + "static/shippingimage2-235e40ab62a8212ea8420c5cac6e550c.jpg";